module.exports = __webpack_public_path__ + "logo_rojeca.svg?66d85f9f061fc10b1f4eaa3a58e5f6a0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_rojeca.svg
// module id = 29
// module chunks = 0